import React from 'react';

import video from '../../../assets/video/video.mp4'
import AboutHero from 'subscreens/Buyer/aboutus/AboutHero';
import AboutMission from 'subscreens/Buyer/aboutus/AboutMission';
import AboutStats from 'subscreens/Buyer/aboutus/AboutStats';
import AboutDreams from 'subscreens/Buyer/aboutus/AboutDreams';
import AboutFeatures from 'subscreens/Buyer/aboutus/Aboutfeatures';
import AboutAgents from 'subscreens/Buyer/aboutus/AboutAgents';
import AboutFaqs from 'subscreens/Buyer/aboutus/AboutFaqs';
import AboutNewsletter from 'subscreens/Buyer/aboutus/AboutNewsletter';
import MyNavbar from 'components/Buyer/navbar/MyNavbar';
import Footer from 'components/Buyer/footer/Footer';
import HeroSection from 'subscreens/general/pageheros/HeroSection';

const About = () => {
  return (
    <>
      <MyNavbar />

      <div className="about-page">
        {/* Hero Section  */}
        <HeroSection
          title="About Us"
          subtitle="Explore Your Real Estate Dream"
          // label="Our Mission"
          image="https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=1920"
          // align="left"
          // size="lg"
        />
        {/* Mission & Vision Section with Video */}
        <AboutMission
          title="Explore your real estate"
          italicText="dream into reality."
          subtitle="Sharing home since 1993."
          description="At Real Nest, we're redefining how people find homes by blending smart technology with human expertise. Our mission is to make real estate simple, transparent, and personalized for every client."
          mission="Our mission is to simplify property ownership through trust, transparency, expertise, care, commitment, and innovation."
          vision="Our vision is to redefine real estate experiences through innovation, excellence, accessibility, trust, technology, and lasting value."
          videoSrc={video}
        />

        {/* Animated Stats Section with Counter */}
        <AboutStats />

        {/* Dreams True Section with Features */}
        <AboutDreams
          title="Turning your real estate dreams true!"
          description="We help you find more than just a property — we help you find your dream lifestyle."
          backgroundImage="https://www.roberthalf.com/content/dam/roberthalf/images/blogs/us/en/hr1/the-value-of-teamwork-in-the-workplace-blog-RH-05-23-24.jpg.jpg"
          buttonText="Get a Quote"
        />

        {/* Dark Features Section */}
        <AboutFeatures
          title="Your Trusted Real Estate Partner"
        />

        {/* Agents Section */}
        {/* <AboutAgents
          title="Start Your Journey With Our\nAmazing Agents"
          buttonText="More Agents >"
        /> */}

      {/* FAQ Section */}
      {/* <AboutFaqs 
        subtitle="FAQ"
        title="Frequently Asked Questions"
      /> */}

      {/* Newsletter Subscribe Section */}
      {/* <AboutNewsletter 
        title="Stay Updated on Latest\nProperty"
        subtitle="Never miss a beat and stay update"
        buttonText="Subscribe"
      /> */}
    </div>
    <Footer/>
    </>
  );
};

export default About;
